import { truncateString } from '@util/string-util'

export const useMetadata = () => {
  const setPageTitle = (parts: string[]) => {
    const truncatedParts = [
      ...parts.map((part) => truncateString(part)),
      'CAPO',
    ]
    const title = truncatedParts.join(' | ')

    if (document.title !== title) {
      document.title = title
    }
  }

  const clearMetadata = () => {
    document.title = 'CAPO'
  }

  return { setPageTitle, clearMetadata }
}
